import React from 'react';

export const ExternalSearchContext = React.createContext<{
  handleClose: Function;
}>({
  handleClose: () => {},
});
